<template>
  <div id="app">
    <error-boundary :type="formtype">
      <router-view/>
    </error-boundary>
  </div>
</template>

<script>
import './assets/scss/main.scss'
import ErrorBoundary from './components/ErrorBoundary'

export default {
  components: {
    ErrorBoundary
  },
  props: {
    url: {
      default: ''
    },
    locale: {
      default: 'de'
    },
    formtype: {
      default: 'simple',
      type: String,
      validator: function (value) {
        return ['simple', 'advanced', 'advanced-online', 'signup', 'extended', 'anniversary'].indexOf(value) !== -1
      }
    }
  },
  created () {
    this.$i18n.locale = this.locale && this.locale.length ? this.locale : 'de'
    this.$store.commit('url', this.url)
    this.$store.commit('locale', this.locale)
    this.$store.commit('formtype', this.formtype)
  }
}

</script>
